import React from "react";

export const EquipmentsContext = React.createContext({});
export const EquipmentsCommonContext = React.createContext({});
export const FavouriteCommonContext = React.createContext({});
